export default {
  title: {
    en: 'Would you like to buy<br class="exceptMobile" /> them in one click?',
  },
  planName: {
    en: `
      {productsPerPeriod, plural, one {# product} other {# products}} per month
    `,
  },
  currBalance: {
    en: 'Balance from your current subscription',
  },
  tax: {
    en: 'Tax',
  },
  shipping: {
    en: 'Shipping',
  },
  free: {
    en: 'FREE',
  },
  total: {
    en: 'Total',
  },
  estimateNote: {
    en: 'Upgrade will come into effect in <span class="brandColor">{upgradeActivationMonth}</span>.',
  },
  nextChargeNote: {
    en: 'Next charge will be in <span class="brandColor">{nextChargeMonth}</span>.',
  },
  attention: {
    en: `
      Plans automatically renew. You may cancel your automatic subscription renewal any time<br />
      <strong>Note:</strong> we will charge your card as soon as you hit Confirm
    `,
  },
  noteTitle: {
    en: 'You are upgrading for a plan:',
  },
  currBalanceDetailed: {
    en: 'Current account balance',
  },
  estimateNoteDetailed: {
    en: 'Upgraded shipment will be in <span class="brandColor">{upgradeActivationMonth}</span>',
  },
  nextChargeNoteDetailed: {
    en: 'Next charge {totalPriceValue} will be in <span class="brandColor">{nextChargeMonth}</span>',
  },
  attentionDetailed: {
    en: 'Renews automatically at {totalPriceValue} per {monthCount, plural, one {# month} other {# months}}. Cancel Anytime.',
  },
  noteProducts: {
    en: '{scentCount, plural, one {# product} other {# products}} per shipment',
  },
  noteMonths: {
    en: 'Shipment every {shippingPeriod, plural, one {# month} other {# months}}',
  },
  noteShipments: {
    en: 'Your prepay for {productCount, plural, one {# shipment} other {# shipments}}',
  },
  chargeNote: {
    en: 'You will be charged {priceValue} <br class="mobile" /> as soon as you press CONFIRM',
  },
  balanceTooltipText: {
    en: 'Your free month will be applied <br class="onlyMobile" />to your upgrade',
  },
  continueToPayment: {
    en: 'Continue to payment',
  },
  back: {
    en: 'Back',
  },
  success: {
    en: 'Success!',
  },
  yourAccountHasBeen: {
    en: 'Your account has been upgraded',
  },
  exploreTheCatalog: {
    en: 'Explore the catalog',
  },
}
